import { render, staticRenderFns } from "./AssignmentEvaluation.vue?vue&type=template&id=79ed2e07"
import script from "./AssignmentEvaluation.vue?vue&type=script&lang=js"
export * from "./AssignmentEvaluation.vue?vue&type=script&lang=js"
import style0 from "./AssignmentEvaluation.vue?vue&type=style&index=0&id=79ed2e07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports